import PicklistMetadata from "../PicklistMetadata";
import MemoryContext from "../../../util/MemoryContext";

class ProjectPlanPhaseNamePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseName";
        this.bounded = true;
        this.enterpriseComponent = "ProjectPlanPhaseLookup";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = {
            "ProjectPlanUSID": MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"]
        };
        this.sortSpecification = null;
        this.static = false;
        this.typeField = null;
        this.typeValue = "Name";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanPhaseNamePicklistMetadata;
